import React from 'react'

const formContext = React.createContext(null)

export default formContext
